import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/ruler-triangle.svg'
import _imports_1 from '@/assets/human.svg'
import _imports_2 from '@/assets/hijab.svg'
import _imports_3 from '@/assets/baby-face.svg'


const _hoisted_1 = { class: "container p-4" }
const _hoisted_2 = {
  key: 0,
  class: "row my-1"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 col-sm-2 offset-sm-1 d-flex aligns-items-center align-content-stretch flex-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-100",
    src: _imports_0,
    alt: "menneske"
  })
], -1)
const _hoisted_4 = { class: "col-9 col-sm-8 offset-sm-1" }
const _hoisted_5 = {
  key: 1,
  class: "row my-1"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 col-sm-2 offset-sm-1 d-flex aligns-items-center align-content-stretch flex-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-100",
    src: _imports_1,
    alt: "menneske"
  })
], -1)
const _hoisted_7 = { class: "col-9 col-sm-8 offset-sm-1" }
const _hoisted_8 = {
  key: 2,
  class: "row my-1"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 col-sm-2 offset-sm-1 d-flex aligns-items-center align-content-stretch flex-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-100",
    src: _imports_0,
    alt: "lineal-trekant"
  })
], -1)
const _hoisted_10 = { class: "col-9 col-sm-8 offset-sm-1" }
const _hoisted_11 = {
  key: 3,
  class: "row my-1"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 col-sm-2 offset-sm-1 d-flex aligns-items-center align-content-stretch flex-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-100",
    src: _imports_2,
    alt: "hijab"
  })
], -1)
const _hoisted_13 = { class: "col-9 col-sm-8 offset-sm-1" }
const _hoisted_14 = {
  key: 4,
  class: "row my-1"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 col-sm-2 offset-sm-1 d-flex aligns-items-center align-content-stretch flex-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-100",
    src: _imports_3,
    alt: "baby"
  })
], -1)
const _hoisted_16 = { class: "col-9 col-sm-8 offset-sm-1" }
const _hoisted_17 = {
  key: 5,
  class: "row d-grid gap-2 col-10 mx-auto"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_20 = {
  key: 6,
  class: "row d-grid gap-2 col-10 mx-auto my-2"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.sessionType === 'document')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("figure", null, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('guidelines.scanningDistance.title')), 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('guidelines.scanningDistance.description')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.sessionType === 'photo')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("figure", null, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('guidelines.distance.title')), 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('guidelines.distance.description')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.sessionType === 'photo')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("figure", null, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('guidelines.angle.title')), 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('guidelines.angle.description')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.sessionType === 'photo')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("figure", null, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('guidelines.headwear.title')), 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('guidelines.headwear.description')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.sessionType === 'photo')
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("figure", null, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('guidelines.children.title')), 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('guidelines.children.description')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.sessionType === 'photo')
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: $setup.takePhoto,
            disabled: $setup.isLoading
          }, [
            ($setup.isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.$t('actions.takePhoto')), 1)
          ], 8, _hoisted_18),
          _createElementVNode("input", {
            class: "d-none",
            type: "file",
            ref: "photoInput",
            accept: "image/*",
            capture: "environment",
            onChange: $setup.onPhotoTaken
          }, null, 544)
        ]))
      : _createCommentVNode("", true),
    ($setup.sessionType === 'document')
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: $setup.scanDocument,
            disabled: $setup.isLoading
          }, [
            ($setup.isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.$t('actions.scanDocument')), 1)
          ], 8, _hoisted_21),
          _createElementVNode("input", {
            class: "d-none",
            type: "file",
            ref: "documentInput",
            accept: "image/*",
            capture: "environment",
            onChange: $setup.onDocumentScanned
          }, null, 544)
        ]))
      : _createCommentVNode("", true)
  ]))
}